const BlockedKeys = require('./BlockedKeys');

module.exports = BlockedKeys;
